unit f_modificacdeap;

{$mode objfpc}

interface

uses
  Classes, SysUtils, un_widget, w_table, web, js, un_tquery, un_formatsettings,
  un_user, f_selezione, DB, un_generator;

type

  { TFrmModificaCDeAP }

  TFrmModificaCDeAP = class(TWidget)
    procedure salva_click(Event: TJSEvent); async;
  published
    procedure idmodifica_click; async;

    utente : TJSHTMLInputElement;
    dtsospeso : TJSHTMLInputElement;
    idmodifica : TJSHTMLInputElement;
    dsnota : TJSHTMLTextAreaElement;

    iddiurno : TJSHTMLInputElement;
    idpensionati : TJSHTMLInputElement;

    // NUOVI CAMPI GIORNI
    fldomenica : TJSHTMLInputElement;
    fllunedi : TJSHTMLInputElement;
    flmartedi : TJSHTMLInputElement;
    flmercoledi : TJSHTMLInputElement;
    flgiovedi : TJSHTMLInputElement;
    flvenerdi : TJSHTMLInputElement;
    flsabato : TJSHTMLInputElement;

    salva: TJSHTMLButtonElement;
    qryModificaCDeAP: TQuery;
    qryComunicazioni: TQuery;
  end;

implementation

{$R *.html}

{ TFrmModificaCDeAP }

procedure TFrmModificaCDeAP.salva_click(Event: TJSEvent);
var
  sID, sDataRaw: string;
  dtScelta: TDateTime;
  nuovoID: Integer;
begin
  sID := Trim(idmodifica.value);

  if sID = '' then
  begin
    ShowMessage('Selezionare un utente.');
    Exit;
  end;

  // --- CONTROLLO OBBLIGO DATA ---
  sDataRaw := Trim(string(dtsospeso.value));

  if (sDataRaw = '') or (Length(sDataRaw) < 10) then
  begin
    ShowMessage(
      'Attenzione: La data di sospensione risulta vuota o incompleta.' +
      sLineBreak +
      'Inserire la data. Se l''utente non è sospeso inserire data antecedente a oggi.'
    );
    Exit;
  end;

  sDataRaw := dtsospeso.value;

  // 1. Gestione Data Sospensione
  if Trim(sDataRaw) = '' then
  begin
    dtScelta := EncodeDate(2000, 1, 1);
  end
  else
  begin
    try
      dtScelta := EncodeDate(
        StrToInt(Copy(sDataRaw, 1, 4)),
        StrToInt(Copy(sDataRaw, 6, 2)),
        StrToInt(Copy(sDataRaw, 9, 2))
      );
    except
      dtScelta := EncodeDate(2000, 1, 1);
    end;
  end;

  try
    // ==========================================================
    // PARTE 1: AGGIORNAMENTO ANAGRAFICA
    // ==========================================================

    qryModificaCDeAP.Close;

    qryModificaCDeAP.SQL.Text :=
      'SELECT IDANAGRAFICA, DTSOSPESOFINOA, FRCDIURNO, FRASSPENSIONATI, ' +
      'FLDOMENICA, FLLUNEDI, FLMARTEDI, FLMERCOLEDI, ' +
      'FLGIOVEDI, FLVENERDI, FLSABATO ' +
      'FROM AN_ANAGRAFICHE WHERE IDANAGRAFICA = ' + sID;

    await(qryModificaCDeAP.Open);

    if not qryModificaCDeAP.IsEmpty then
    begin
      qryModificaCDeAP.Edit;

      qryModificaCDeAP.FieldByName('DTSOSPESOFINOA').AsDateTime :=
        dtScelta;

      qryModificaCDeAP.FieldByName('FRCDIURNO').AsString :=
        iddiurno.value;

      qryModificaCDeAP.FieldByName('FRASSPENSIONATI').AsString :=
        idpensionati.value;

      // NUOVI CAMPI GIORNI
      qryModificaCDeAP.FieldByName('FLDOMENICA').AsString :=
        fldomenica.value;

      qryModificaCDeAP.FieldByName('FLLUNEDI').AsString :=
        fllunedi.value;

      qryModificaCDeAP.FieldByName('FLMARTEDI').AsString :=
        flmartedi.value;

      qryModificaCDeAP.FieldByName('FLMERCOLEDI').AsString :=
        flmercoledi.value;

      qryModificaCDeAP.FieldByName('FLGIOVEDI').AsString :=
        flgiovedi.value;

      qryModificaCDeAP.FieldByName('FLVENERDI').AsString :=
        flvenerdi.value;

      qryModificaCDeAP.FieldByName('FLSABATO').AsString :=
        flsabato.value;

      qryModificaCDeAP.Post;

      await(qryModificaCDeAP.ApplyUpdates);
    end;

    // Se non ci sono note, il salvataggio è comunque completato
    if dsnota.value = '' then
    begin
      ShowMessage('Salvataggio completato con successo.');
      Close;
      Exit;
    end;

    // ==========================================================
    // PARTE 2: REGISTRAZIONE NELLA TABELLA VO_COMUNICAZIONI
    // ==========================================================

    nuovoID := await(GetNextId('VO_COMUNICAZIONI'));

    qryComunicazioni.Close;

    qryComunicazioni.SQL.Text :=
      'SELECT * FROM VO_COMUNICAZIONI WHERE 1=0';

    if qryComunicazioni.Fields.Count > 0 then
      qryComunicazioni.Fields.Clear;

    await(qryComunicazioni.Open);

    qryComunicazioni.Insert;

    qryComunicazioni.FieldByName('IDCOMUNICAZIONE').AsInteger :=
      nuovoID;

    qryComunicazioni.FieldByName('IDSOCIETA').AsString :=
      'DON001';

    qryComunicazioni.FieldByName('DTDATA').AsDateTime :=
      Now;

    qryComunicazioni.FieldByName('IDUTENTE').AsInteger :=
      StrToIntDef(sID, 0);

    qryComunicazioni.FieldByName('DSUTENTE').AsString :=
      utente.value;

    qryComunicazioni.FieldByName('DTSOSPESOFINOA').AsDateTime :=
      dtScelta;

    qryComunicazioni.FieldByName('DSNOTE').AsString :=
      dsnota.value;

    try
      qryComunicazioni.Post;
      await(qryComunicazioni.ApplyUpdates);

      ShowMessage('Salvataggio completato con successo.');

      Close;

    except
      on E: Exception do
        ShowMessage(
          'Errore durante l''invio dei dati (ApplyUpdates): ' +
          E.Message
        );
    end;

  except
    on E: Exception do
      ShowMessage(
        'Errore durante la procedura: ' +
        E.Message
      );
  end;
end;


procedure TFrmModificaCDeAP.idmodifica_click;
begin
  with TFrmSelezione.Create do
  begin
    OpenQrySeleziona := procedure async
    begin
      CloseForm := True;
      QrySeleziona.Close;

      QrySeleziona.SQL.Text :=
        'SELECT idanagrafica as id, ' +
        'dsragionesociale as utente, ' +
        'dtsospesofinoa, ' +
        'frcdiurno, ' +
        'frasspensionati, ' +

        // NUOVI CAMPI GIORNI
        'fldomenica, ' +
        'fllunedi, ' +
        'flmartedi, ' +
        'flmercoledi, ' +
        'flgiovedi, ' +
        'flvenerdi, ' +
        'flsabato ' +

        'FROM an_anagrafiche';

      AWait(QrySeleziona.Open);
    end;

    if AWait(Show) = mrOK then
    begin
      // DATI ESISTENTI
      utente.value :=
        QrySeleziona.FieldByName('utente').AsString;

      idmodifica.value :=
        QrySeleziona.FieldByName('id').AsString;

      iddiurno.value :=
        QrySeleziona.FieldByName('frcdiurno').AsString;

      idpensionati.value :=
        QrySeleziona.FieldByName('frasspensionati').AsString;

      // ========================================================
      // RIPORTA I VALORI ESISTENTI DEI GIORNI
      // ========================================================

      fldomenica.value :=
        QrySeleziona.FieldByName('fldomenica').AsString;

      fllunedi.value :=
        QrySeleziona.FieldByName('fllunedi').AsString;

      flmartedi.value :=
        QrySeleziona.FieldByName('flmartedi').AsString;

      flmercoledi.value :=
        QrySeleziona.FieldByName('flmercoledi').AsString;

      flgiovedi.value :=
        QrySeleziona.FieldByName('flgiovedi').AsString;

      flvenerdi.value :=
        QrySeleziona.FieldByName('flvenerdi').AsString;

      flsabato.value :=
        QrySeleziona.FieldByName('flsabato').AsString;

      // ========================================================
      // DATA SOSPENSIONE
      // ========================================================

      if not QrySeleziona.FieldByName('dtsospesofinoa').IsNull then
      begin
        if QrySeleziona.FieldByName('dtsospesofinoa').AsDateTime <
           EncodeDate(2010, 1, 1) then
        begin
          dtsospeso.value := '';
        end
        else
        begin
          dtsospeso.value :=
            FormatDateTime(
              'yyyy-mm-dd',
              QrySeleziona.FieldByName('dtsospesofinoa').AsDateTime
            );
        end;
      end
      else
        dtsospeso.value := '';
    end;
  end;
end;


initialization
  RegisterWeb(TFrmModificaCDeAP);

end.

